export const getFilteredValue = (items: unknown[] = [], value: string) => {
  const search = value.trim().toLowerCase();
  return items.filter(item => item.name.toLowerCase().includes(search));
};
